<template>
    <li class="dropdown-item" @click.stop="$emit('select', value)">
        <a href="#" :class="{ mark: mark, selected: selected }">
            {{ value.text }}<span :class="{ mark: mark, selected: selected }"></span>
        </a>
    </li>
</template>

<script>
export default {
    name: 'select-item',
    props: ['value', 'selected', 'mark'],
    data() {
        return {};
    },
};
</script>

<style lang="scss">
li.dropdown-item {
    padding: 5px 20px;

    > a {
        position: relative;
        white-space: nowrap;
        color: #9ca5b0;
        font-size: 13px;
        line-height: 13px;
        transition: color 0.25s ease;
        font-weight: 500;
        // padding: 7px 9px;
        padding-top: 7px;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;

        background: none;
        background-color: transparent;

        &.mark {
            padding-left: 22px;
        }

        &.selected {
            color: #3b3e47;
        }
    }

    &:hover > a {
        color: #3b3e47;
    }

    &:hover span.mark {
        border: 1px solid #3b3e47;
    }

    /* Create a custom radio */
    span.mark {
        position: absolute;
        top: 7px;
        left: 0;
        height: 13px;
        width: 13px;
        border: 1px solid #8e919b;
        border-radius: 50%;
        transition: all 0.25s ease-in-out;

        &.selected {
            border: 1px solid #6c3e91;
            background-color: #6c3e91;

            &:after {
                display: block;
            }
        }

        /* Create the mark/indicator (hidden when not checked) */
        &:after {
            content: '';
            position: absolute;
            display: none;
            /* Style the mark/indicator */
            left: 4px;
            top: 4px;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: white;
        }
    }
}
</style>
